import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.dataset.showMorePlaced) return
    const paragraph = this.element.previousElementSibling
    if (!paragraph) return

    this.element.dataset.showMorePlaced = "true"
    paragraph.appendChild(this.element)
  }
}
